// Short names for navigation items in collapsed view
const shortNames = {
  // Dashboard items
  dashboard: 'Dash',
  default: 'Home',
  analytics: 'Stats',

  // Sample page
  sample: 'Sample',

  // Actual menu items from other.js
  'lp-analysis': 'Analyze',
  'competitors-history': 'Rivals',
  reviews: 'Reviews',
  interviews: 'Interview',
  'icp-generator': 'ICP',
  'market-trends': 'Trends'

  // Add more mappings as needed
};

export default shortNames;
